var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCooking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Animal-Products-Fried-Egg-Pan--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Animal Products Fried Egg Pan Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 5.53a2 2 0 1 0 2 2 2 2 0 0 0 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0a10 10 0 0 0 -8.29 15.59 0.5 0.5 0 0 1 -0.06 0.64L0.44 21.44a1.49 1.49 0 0 0 0 2.12 1.5 1.5 0 0 0 2.12 0l5.21 -5.21a0.5 0.5 0 0 1 0.64 -0.06A10 10 0 1 0 14 0Zm2.28 16.07a1.3 1.3 0 0 1 -1.74 -1.21 4.32 4.32 0 0 0 -4.33 -4.32 4.22 4.22 0 0 0 -1.51 0.28 0.88 0.88 0 0 1 -1.19 -0.82 6.49 6.49 0 1 1 8.77 6.08Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCooking);
export default ForwardRef;